import { createRoute } from "@tanstack/react-router";
import { FpNonRelationalMetricsChart } from "@/components/teams/fp-nonrelational-metrics-chart";
import { TeamRosterPage } from "@/components/teams/team-roster-page";
import { Route as authenticatedRoute } from "../_authenticated";

const members = [
  {
    name: "Zach Starbeck",
    title: "FP Non Relational Channel Champion",
    ownerId: "4102fc39-e7b1-4e65-b3a5-9d94ea8bd1d3",
    image: "/assets/headshots/zach-starbeck.png",
  },
  {
    name: "Chase Megyeri",
    title: "Case Study Channel Champion",
    ownerId: "e7b4176c-bd08-4c14-b566-78712b239fad",
    image: "/assets/headshots/chase-megyeri.png",
  },
  {
    name: "Mike Turner",
    title: "Campus Channel Champion",
    ownerId: "b14ce866-6bb9-4362-b86f-75af78053a09",
    image: "/assets/headshots/mike-turner.png",
  },
];

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/teams/fp/consultants/non-relational",
  component: () => (
    <TeamRosterPage team="Non Relational Consultants" members={members}>
      <FpNonRelationalMetricsChart />
    </TeamRosterPage>
  ),
});
